import React, { useEffect, useState } from 'react'
import Select from 'meinian-package/src/baseComponent/select'
import request from 'meinian-package/src/utils/request'
import { targetCategory } from 'common'

export default ({ currentTask, value, onChange, placement, ulStyle }) => {
  const [option, setOption] = useState([])

  useEffect(() => {
    fetchCategories()
  }, [currentTask.id])

  const fetchCategories = async () => {
    request.get('/zhikuan/ins/blog/mission/mission-blog-category-selector', { params: { missionId: currentTask.id } }).then(result => {
      if (result) {
        const _option = result.map(item => ({
          value: item.id,
          label: targetCategory(item.gender, item.rootCategory, item.category),
          ...item
        }))
        setOption(_option)
      }
    })
  }

  return <Select
    placement={placement}
    data={option}
    value={value}
    onChange={onChange}
    placeholder="目标品类"
    displayStyle={{ maxWidth: 'unset' }}
    ulStyle={ulStyle}
  />
}
